export default "__VITE_ASSET__Dp$bBFIW__"